import axiosApiClient, { axiosApiPublicClient } from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/subscription";

class SubscriptionService {
  fetchSubscriptions = async () => {
    try {
      const response = await axiosApiPublicClient.get(
        `api${BASE_URL}/one-time`,
      );
      if (response.status !== 200) {
        throw new Error();
      }
      const data = response.data;
      return data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching subscriptions");
    }
  };

  getSubscriptionsCreditsHistory = async (page) => {
    try {
      const response = await axiosApiClient.get(
        `${BASE_URL}/history?page=${page}`,
      );
      if (response.status !== 200) {
        throw new Error();
      }
      const data = response.data;
      return data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while fetching subscriptions credits history",
      );
    }
  };

  choosePlan = async (body) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/subscribe`, body);
      if (response.status !== 201) {
        throw new Error();
      }
      const data = response.data;
      return data;
    } catch (err) {
      throw handleError(err, "Error occurred while choosing subscription plan");
    }
  };

  rechargeCredits = async (planId, paymentMethod) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/subscribe`, {
        planId,
        paymentMethod,
      });
      if (response.status < 200 || response.status >= 300) {
        throw new Error();
      }
      const data = response.data;
      return data;
    } catch (err) {
      throw handleError(err, "Error occurred while recharging.");
    }
  };
}

const subscriptionService = new SubscriptionService();

export default subscriptionService;
